import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { PermissionSetType } from 'api/models';
import { Spotlight } from 'api/spotlight/types';
import { View } from 'api/views/types';
import {
  Loader,
  Empty,
} from 'components/organisms/projects/project-sidebar/spaces-menu/styles';
import { CustomiseButton } from '../components';
import { NonDeletedView } from '../types';
import { SubMenu } from './components';
import { renderViewListItem } from './view-list-item';

const EmptyStyled = styled(Empty)`
  line-height: var(--height-base);
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface Props<ViewDefinition = any> {
  icon: ReactNode;
  title: ReactNode;
  menuKey: string;
  loadingMessage: ReactNode;
  emptyMessage: ReactNode;
  views: NonDeletedView<ViewDefinition>[];
  isEmpty: boolean;
  loading: boolean;
  currentUserId: number;
  onViewSelect: (view: View<ViewDefinition>) => void;
  onViewEdit: (view: View<ViewDefinition>) => void;
  onViewDelete: (view: View<ViewDefinition>) => void;
  onViewCustomise: (key: string) => void;
  currentUserPermissionSetType: PermissionSetType;
  isExternalUser: boolean;
  isProjectTaskList: string;
  onSpotlightView: (view: View<ViewDefinition>) => void;
  spotlightsMap: Record<number, Spotlight>;
}

export const CUSTOMISATION_ALLOWED_VIEWS = ['mySavedViews', 'sharedViews'];

export const renderViewList = ({
  icon,
  title,
  menuKey,
  loadingMessage,
  emptyMessage,
  views,
  isEmpty,
  loading,
  currentUserId,
  onViewSelect,
  onViewEdit,
  onViewDelete,
  onViewCustomise,
  currentUserPermissionSetType,
  isExternalUser,
  isProjectTaskList,
  onSpotlightView,
  spotlightsMap,
}: Props): JSX.Element => {
  const allowCustomisation = CUSTOMISATION_ALLOWED_VIEWS.includes(menuKey);

  return (
    <SubMenu
      icon={icon}
      title={
        <TitleWrapper>
          <>{title}</>
          {allowCustomisation && (
            <CustomiseButton
              disabled={isEmpty}
              onClick={(e) => {
                if (e) {
                  e.stopPropagation();
                }
                onViewCustomise(menuKey);
              }}
            />
          )}
        </TitleWrapper>
      }
      key={menuKey}
    >
      {loading ? (
        <Loader>{loadingMessage}</Loader>
      ) : views.length > 0 ? (
        views.map((x) =>
          renderViewListItem({
            view: x,
            currentUserId,
            onViewSelect,
            onViewEdit,
            onViewDelete,
            currentUserPermissionSetType,
            isExternalUser,
            isProjectTaskList,
            onSpotlightView,
            isSpotlighted: !!spotlightsMap[x[1]?.viewId],
          }),
        )
      ) : (
        <EmptyStyled>{emptyMessage}</EmptyStyled>
      )}
    </SubMenu>
  );
};
